<template>
  <div class="table">
    <div class="table__head">
      <div
        class="head__column"
        data-state="active"
      >
        <AppTitle
          class="c-title--dark"
          :data="{
            content: data.days[1],
          }"
          :isAnimated="false"
          data-lazyanimation="title"
        />
      </div>
    </div>

    <div class="table__body">
      <span class="table__vertical-line u-hidden--until-ipadL" />

      <div class="table__column">
        <TimetableItem
          v-for="(schedule, ind) in data.events.secondDay"
          :starts="starts"
          :key="`schedule_${ind}`"
          :data="schedule"
          class="schedule__item"
        />
        <div class="schedule__hour" v-for="hour in hours" :key="hour">
          <time>{{ hour }}</time>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/scripts/utils';

import AppTitle from '@/components/AppTitle.vue';
import TimetableItem from '@/components/TimeTableItem.vue';

import starts from '@/assets/data/starts.json';

export default {
  name: 'SingleTable',

  components: {
    AppTitle,
    TimetableItem,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      starts,
      currentDay: 0,

      isMobile: isMobile(),
      col: 0,
    };
  },

  computed: {
    hours() {
      return starts.filter(start => starts.indexOf(start) % 6 === 0 && starts.indexOf(start) < 140);
    },
  },

  mounted() {
    this.$eventHub.$on('windowResize', this.resize);
    Object.keys(this.data.events).forEach(key => this.data.events[key].sort((a, b) => a - b));
  },

  methods: {
    showCol(index) {
      if (!this.isMobile) return true;

      return (index === this.currentDay);
    },

    resize() {
      this.isMobile = isMobile();
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('windowResize');
  },
};
</script>

<style lang="scss" scoped>
$halfHourPx: 260px;

.table {
  display: flex;
  flex-flow: row wrap;

  &__head,
  &__body {
    position: relative;
    width: 100%;
    flex: 0 0 100%;

    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .head__column,
  .table__column {
    position: relative;
    flex: 0 0 100%;

    @include mq(ipadL) {
      flex: 0 0 calc(65% - 40px);

      &::v-deep .schedule__item {
        width: 35vw;
      }
    }
  }

  .table__column .schedule__hour::before,
  .head__column::before {
    content: '';

    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;

    background-color: rgba($color-white, 0.4);
  }

  .head__column {
    display: inline-block;
    flex: 0 0 auto;
    padding: 30px 30px 30px 20px;

    &::before {
      content: none;
    }

    @include mq($until: ipadL) {
      transition: transform 0.35s $outBack;

      &:last-child {
        border-left: 1px solid $color-white;
      }

      &[data-current="1"] {
        transform: translateX(-50%);
      }
    }

    @include mq(ipadL) {
      flex: 0 0 calc(65% - 40px);
      padding: 0 0 $unit-vh * 3 0;

      &::before {
        content: '';
        bottom: $unit-vh;
      }
    }
  }

  &__column {
    time {
      margin-left: 15px;

      text-align: left;
      font-size: 25px;
      color: var(--color-headline-light);

      @include mq($until: mobileL) {
        transform: rotate(-90deg) translateY(-35px);
        transform-origin: center center;
      }
    }

    .schedule__hour {
      position: relative;
      height: $halfHourPx;

      display: flex;
      align-items: center;
      justify-content: flex-start;

      &::before {
        bottom: 0;
      }

      &:last-child::after {
        content: none;
      }
    }

    .schedule__item {
      position: absolute;
      top: 0;
      right: 5px;

      z-index: 2;
    }
  }

  &__vertical-line {
    position: relative;
    width: 1px;
    margin-left: 35px;

    order: 2;
    align-self: stretch;

    background-color: rgba($color-white, 0.4);
  }

  @include mq($until: ipadL) {
    margin-top: 40px;

    &__head {
      flex-flow: row nowrap;
      border-top: 1px solid $color-white;
      border-bottom: 1px solid $color-white;
    }
  }
}
</style>


<style lang="scss">
.timetable .table sup {
  position: relative;
  top: -0.6em;
  font-size: 30%;

  color: $color-white;

  @include mq(ipadP) {
    top: -0.9em;
    font-size: 25%;
  }

  @include mq(ipadL) {
    top: -1.8em;
    font-size: 15%;
  }
}
</style>
